import { shade } from 'polished'
import styled, { css } from 'styled-components'

interface IQuantityCounterStyledProps {
  $isValueEditable?: boolean
}

const HOVER_SHADE = 0.05

export const QuantityCounterStyled = styled.div<IQuantityCounterStyledProps>`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space.xsmall};

  padding: 0;
  background-color: ${({ theme }) => theme.colors.neutral};
  border-radius: ${({ theme }) => theme.typography.pxToRem(8)};

  min-width: ${({ theme }) => theme.typography.pxToRem(90)};

  ${({ $isValueEditable, theme }) =>
    $isValueEditable &&
    css`
      border: ${theme.typography.pxToRem(1)} solid transparent;

      &:hover {
        background-color: ${shade(HOVER_SHADE, theme.colors.neutral)};
      }

      &:focus-within {
        background-color: ${theme.colors.content.contentBackground};
        border-color: ${theme.colors.form.field.borderActive};
      }
    `}
`
